<footer id="brd-footer">
  <div class="brd-footer-top">
    <div class="brd-nav">
      <img src="assets/images/board-logo-dark.png" />
      <div class="brd-pages">
        <a *ngFor="let page of pages" [routerLink]="[page.link]">{{ page.text }}</a>
      </div>
    </div>
    <div class="brd-link">
      <span
        >The content shared within the Demo Portal, including both demos and enablement materials, is intended solely for use within the
        context of the Demo Portal.<br />We kindly ask that this material not be shared externally, as it is designed for internal
        enablement and demonstration purposes only.</span
      >
    </div>
    <div class="brd-link">
      <mat-icon svgIcon="mail-16"></mat-icon>
      <span>{{ "demoportal@board.com" }}</span>
    </div>
  </div>
  <div class="brd-footer-bottom">Copyright © 2026 Board International - All rights reserved.</div>
</footer>
